export async function getJsonSync(url, headers) {
    try {
        let response = await fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Pragma':'no-cache',
                'Cache-Control': 'no-cache',
                ...headers
            },
        });

        if (response == null) {
            console.error('Error: Response is null');
            return null;
        }

        let json = await response.json();

        if (json == null) {
            console.error('Error: JSON is null');
            return null;
        }

        return json;
    }
    catch (error) {
        console.error(error);
        return null;
    }
}

export async function postJsonSync(url, body, headers) {
    try {
        let response = await fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Pragma':'no-cache',
                'Cache-Control': 'no-cache',
                ...headers
            },
            body: body ? JSON.stringify(body) : null,
        });

        if (response == null) {
            console.error('Error: Response is null');
            return null;
        }

        let json = await response.json();

        if (json == null) {
            console.error('Error: JSON is null');
            return null;
        }

        return json;
    }
    catch (error) {
        console.error(error);
        return null;
    }
}
